/**
 * Capitalize first letter of string and lowercase remaining characetrs
 * @param {string} inputString
 * @return {string} Formatted string
 */

export const capitalizeFirstLetterLowercaseOther = (str) => {
  const stringvar = (str && str.trim()) || '';
  return stringvar && stringvar[0].toUpperCase() + stringvar.substring(1).toLowerCase();
};

/**
 * Capitalize only first letter of string, while keep others unchanged
 * @param {string} inputString
 * @return {string} Formatted string
 */
/* eslint no-param-reassign: ["error", { "props": false }] */
export const capitalizeOnlyFirstLetter = (str) => {
  const stringvar = (str && str.trim()) || '';
  return stringvar && stringvar[0].toUpperCase() + stringvar.substring(1);
};

/**
 * Removes all the leading zeros from input string or number
 * @param {string|Number} input
 * @return {string} String without zero at start
 */

export const trimZeroFromStart = (str) => {
  let strvar = str;
  if (typeof strvar === 'string' || typeof strvar === 'number') {
    strvar += ''; // to change number to string in case number is string
    return strvar.replace(/^0+/g, '');
  }
  return strvar;
};

export const decodeEntities = (input) => {
  // using client-side only
  if (typeof window === 'undefined' || typeof input !== 'string') {
    return input;
  }

  const element = document.createElement('textarea');
  element.innerHTML = input;
  return element.childNodes.length === 0 ? '' : element.childNodes[0].nodeValue;
};
